 export const formatSlug = (value) => {
  return value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')      // spaces → -
    .replace(/[^a-z0-9-]/g, '') // remove special chars
    .replace(/-+/g, '-');      // avoid multiple -
};